/**
 * Composes five redesigned RMA list columns into a single TableRow with shared navigation and analytics.
 */
import type { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import TableRow from "../../../../../components/table/components/table-row/table-row";
import { APP_PATHS } from "../../../../../constants/app-paths";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaListItemStore from "../../../rma-list-page/stores/rma-item-store";
import TableColumnCustomer from "../table-column-customer/table-column-customer";
import TableColumnItems from "../table-column-items/table-column-items";
import TableColumnResolutions from "../table-column-resolutions/table-column-resolutions";
import TableColumnRmaDetails from "../table-column-rma-details/table-column-rma-details";
import TableColumnStatus from "../table-column-status/table-column-status";

export interface IRmaListTableRowProps {
    rma: RmaListItemStore;
}

const RmaListTableRow: React.FC<IRmaListTableRowProps> = ({ rma }) => {
    const navigate = useNavigate();
    const onOrderNumberClick = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        rmsMixpanelStore.trackEvent("d&_order");
    };
    const onSelect = () => {
        rmsMixpanelStore.trackEvent("d&_table_row");
        navigate({ pathname: `${APP_PATHS.RETURNS}/${rma.rmaId}` });
    };
    return (
        <TableRow
            skipWrapingCell
            cells={[
                <TableColumnRmaDetails key="rma" rma={rma} onOrderNumberClick={onOrderNumberClick} />,
                <TableColumnResolutions key="res" rma={rma} />,
                <TableColumnItems key="items" rma={rma} />,
                <TableColumnCustomer key="cust" rma={rma} />,
                <TableColumnStatus key="st" rma={rma} />,
            ]}
            onSelect={onSelect}
        />
    );
};

export default RmaListTableRow;
